import { createFeatureSelector, createSelector } from "@ngrx/store";
import { adminDashboardFeatureKey, State } from "./admin.reducer";

export const selectAdminDashboardState =
  createFeatureSelector<State>(adminDashboardFeatureKey);

export const selectUnconfirmedPortalRequests = createSelector(
  selectAdminDashboardState,
  (state: State) => state.unconfirmedPortalRequestsResponse
);

export const selectAdminDashboardLoading = createSelector(
  selectAdminDashboardState,
  (state: State) => state.loading
);

export const selectAllSystemUsers = createSelector(
  selectAdminDashboardState,
  (state: State) => state.allSystemUsersResponse
);

export const selectCaseContacts = createSelector(
  selectAdminDashboardState,
  (state: State) => state.caseContacts
);

export const selectClinics = createSelector(
  selectAdminDashboardState,
  (state: State) => state.clinics
);

export const selectProviders = createSelector(
  selectAdminDashboardState,
  (state: State) => state.providers
);
